// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__nunitoSans_c98a46', '__nunitoSans_Fallback_c98a46'"},"className":"__className_c98a46","variable":"__variable_c98a46"};